import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, X, AlarmClock } from "lucide-react";

const MONTHS = ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];

export default function CounselorNotices() {
  const [notices, setNotices] = useState([]);
  const [reminderDismissed, setReminderDismissed] = useState(false);
  const [monthSubmitted, setMonthSubmitted] = useState(true);

  const currentMonth = MONTHS[new Date().getMonth()];

  useEffect(() => {
    api.get("/notifications/mine").then((r) => setNotices(r.data)).catch(() => {});
    api.get("/records", { params: { type: "monthly_report" } }).then((r) => {
      const ok = r.data.some(
        (rec) => rec.data?.month === currentMonth && ["submitted", "received"].includes(rec.submit_status)
      );
      setMonthSubmitted(ok);
    }).catch(() => {});
    // eslint-disable-next-line
  }, []);

  const dismiss = async (id) => {
    setNotices((n) => n.filter((x) => x.id !== id));
    try { await api.post(`/notifications/${id}/read`); } catch {}
  };

  const unread = notices.filter((n) => !n.read);
  const showReminder = !monthSubmitted && !reminderDismissed;
  if (unread.length === 0 && !showReminder) return null;

  return (
    <div className="space-y-2" data-testid="counselor-notices">
      {showReminder && (
        <div className="flex items-center justify-between gap-3 rounded-xl border border-[#DDA74A]/40 bg-[#DDA74A]/10 p-4" data-testid="monthly-report-reminder">
          <div className="flex items-center gap-3 min-w-0">
            <AlarmClock className="w-5 h-5 text-[#a8791f] shrink-0" />
            <div>
              <div className="text-sm font-semibold text-[#1A201C]">
                لم تُرسل تقرير شهر {currentMonth} للمشرف بعد
              </div>
              <div className="text-xs text-[#4A554E] mt-0.5">
                احرص على إعداده وإرساله قبل نهاية الشهر —{" "}
                <Link to="/counselor/monthly-report" className="text-[#3E6A56] font-semibold underline underline-offset-2" data-testid="reminder-goto-report">
                  إعداد التقرير الآن
                </Link>
              </div>
            </div>
          </div>
          <button onClick={() => setReminderDismissed(true)} className="p-1.5 rounded-lg text-[#4A554E] hover:bg-[#DDA74A]/15 shrink-0" data-testid="dismiss-reminder">
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
      {unread.map((n) => (
        <div key={n.id} className="flex items-center justify-between gap-3 rounded-xl border border-[#3E6A56]/30 bg-[#3E6A56]/5 p-4" data-testid={`counselor-notice-${n.id}`}>
          <div className="flex items-center gap-3 min-w-0">
            <CheckCircle2 className="w-5 h-5 text-[#3E6A56] shrink-0" />
            <div>
              <div className="text-sm font-semibold text-[#1A201C]">
                أكد المشرف استلام تقريرك الشهري{n.month ? ` — شهر ${n.month}` : ""}
              </div>
              <div className="text-xs text-[#4A554E] mt-0.5">
                {new Date(n.created_at).toLocaleString("ar-EG", { dateStyle: "medium", timeStyle: "short" })}
              </div>
            </div>
          </div>
          <button onClick={() => dismiss(n.id)} className="p-1.5 rounded-lg text-[#4A554E] hover:bg-[#3E6A56]/10 shrink-0" data-testid={`dismiss-notice-${n.id}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
